/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：614
 */

"use strict"

export { r as a }
var r = function () {
  for (var /* [auto-meaningful-name] */arguments$length = arguments.length, t = new Array(arguments$length), n = 0; n < arguments$length; n++) {
    t[n] = arguments[n]
  }
  return t
}
export default r
